// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"93":"99c09ec7","378":"6f6ffbad","409":"cf40943a","704":"d7726642"}[chunkId] + ".js";
};